module.exports = __webpack_public_path__ + "1f5425c3beaeb1e65a5f2107328dbb90.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Instructors/images/icons/website.svg
// module id = 29
// module chunks = 0 1